export const AI_SIGNAL_DEFAULT = {
  score: "8.5",
  signal: "Strong Positive",
};

export const AI_SYMBOLS = [
  { symbol: "xrp_usdt", score: "8.5", signal: "Strong Positive" },
  { symbol: "sol_usdt", score: "7.2", signal: "Positive" },
  { symbol: "ada_usdt", score: "3.2", signal: "Negative" },
  { symbol: "shib_usdt", ...AI_SIGNAL_DEFAULT },
  { symbol: "doge_usdt", ...AI_SIGNAL_DEFAULT },
  { symbol: "bnb_usdt", ...AI_SIGNAL_DEFAULT },
  { symbol: "btc_usdt", ...AI_SIGNAL_DEFAULT },
  { symbol: "meme_usdt", ...AI_SIGNAL_DEFAULT },
  { symbol: "pepe_usdt", ...AI_SIGNAL_DEFAULT },
  { symbol: "sui_usdt", ...AI_SIGNAL_DEFAULT },
  { symbol: "eth_usdt", ...AI_SIGNAL_DEFAULT },
];

export function getAiSignalBySymbol(symbol) {
  const key = String(symbol || "").toLowerCase();
  return AI_SYMBOLS.find((item) => item.symbol === key) || null;
}
